/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerPositionsByUserIDOptions,
  GetLedgerPositionsByUserIDStatus200,
  GetLedgerPositionsByUserIDStatus400,
  GetLedgerPositionsByUserIDStatus404,
  GetLedgerPositionsByUserIDStatus500,
} from '../types/GetLedgerPositionsByUserID'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerPositionsByUserID } from '../clients/getLedgerPositionsByUserID'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerPositionsByUserIDQueryKey = ({
  path,
}: Omit<GetLedgerPositionsByUserIDOptions, 'headers'>) =>
  [{ url: '/v1/ledger/positions/:user_id', params: path }] as const

type GetLedgerPositionsByUserIDQueryKey = ReturnType<typeof getLedgerPositionsByUserIDQueryKey>

export function getLedgerPositionsByUserIDQueryOptions(
  { path }: GetLedgerPositionsByUserIDOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerPositionsByUserIDQueryKey({ path })
  return queryOptions<
    GetLedgerPositionsByUserIDStatus200,
    ResponseErrorConfig<
      | GetLedgerPositionsByUserIDStatus400
      | GetLedgerPositionsByUserIDStatus404
      | GetLedgerPositionsByUserIDStatus500
    >,
    GetLedgerPositionsByUserIDStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerPositionsByUserID({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get a specific user's positions
 * {@link /v1/ledger/positions/:user_id}
 */
export function useGetLedgerPositionsByUserID<
  TData = GetLedgerPositionsByUserIDStatus200,
  TQueryData = GetLedgerPositionsByUserIDStatus200,
  TQueryKey extends QueryKey = GetLedgerPositionsByUserIDQueryKey,
>(
  {
    path,
  }: {
    path:
      | GetLedgerPositionsByUserIDOptions['path']
      | (() => GetLedgerPositionsByUserIDOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerPositionsByUserIDStatus200,
        ResponseErrorConfig<
          | GetLedgerPositionsByUserIDStatus400
          | GetLedgerPositionsByUserIDStatus404
          | GetLedgerPositionsByUserIDStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getLedgerPositionsByUserIDQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getLedgerPositionsByUserIDQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerPositionsByUserIDStatus400
      | GetLedgerPositionsByUserIDStatus404
      | GetLedgerPositionsByUserIDStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
